import {
  ApiKeyScope,
  type ApiKey,
  type CreateApiKeyRequest,
  type UpdateApiKeyRequest,
} from '@nucleus-commerce/api-client/admin';

import { parseOrigins, type ApiKeyFormValues } from '../schemas/api-key-form-schema';

/**
 * Secret keys take no origins. No scopes picked means every scope, which the backend reads from
 * an empty list; the rate limit is left out to use the platform default.
 */
export function toApiKeyCreate(values: ApiKeyFormValues): CreateApiKeyRequest {
  return {
    name: values.name,
    kind: values.kind,
    allowedOrigins: values.kind === 'publishable' ? parseOrigins(values.allowedOrigins) : [],
    scopes: values.scopes,
    ...(values.rateLimitPerMinute ? { rateLimitPerMinute: Number(values.rateLimitPerMinute) } : {}),
  };
}

export function fromApiKey(key: ApiKey): ApiKeyFormValues {
  return {
    name: key.name,
    kind: key.kind,
    allowedOrigins: key.allowedOrigins.join('\n'),
    scopes: key.scopes.filter((scope): scope is ApiKeyScope =>
      (Object.values(ApiKeyScope) as string[]).includes(scope),
    ),
    rateLimitPerMinute: key.rateLimitPerMinute === null ? '' : String(key.rateLimitPerMinute),
  };
}

/**
 * Every editable field is sent; the kind never changes. A blank rate limit goes out as null,
 * which returns the key to the platform default.
 */
export function toApiKeyUpdate(values: ApiKeyFormValues): UpdateApiKeyRequest {
  return {
    name: values.name,
    allowedOrigins: values.kind === 'publishable' ? parseOrigins(values.allowedOrigins) : [],
    scopes: values.scopes,
    rateLimitPerMinute: values.rateLimitPerMinute ? Number(values.rateLimitPerMinute) : null,
  };
}
